import { render, staticRenderFns } from "./UnderReviewPage.vue?vue&type=template&id=170c91e7"
import script from "./UnderReviewPage.vue?vue&type=script&lang=ts"
export * from "./UnderReviewPage.vue?vue&type=script&lang=ts"
import style0 from "./UnderReviewPage.vue?vue&type=style&index=0&id=170c91e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports